// Admin mail outbox queries: queue page (server-side pagination/filters),
// global status counters, and the per-letter detail for the drawer.
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useIsPlatformAdmin } from '../../../shared/scope/useCurrentScope.js';

import {
  getAdminOutboxById,
  getAdminOutboxDetailQueryKey,
  getAdminOutboxQueryKey,
  getAdminOutboxStatusCounts,
  getAdminOutboxStatusCountsQueryKey,
  listAdminOutbox,
  type AdminOutboxFilters,
} from '../api/admin.client.js';

export function useAdminOutbox(filters: AdminOutboxFilters) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminOutboxQueryKey(filters),
    queryFn: () => listAdminOutbox(filters),
    enabled: isPlatformAdmin,
    // Page/filter changes keep the previous rows visible instead of flashing
    // a skeleton — same contract as the users/workspaces screens.
    placeholderData: keepPreviousData,
  });
}

export function useAdminOutboxStatusCounts() {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminOutboxStatusCountsQueryKey(),
    queryFn: () => getAdminOutboxStatusCounts(),
    enabled: isPlatformAdmin,
  });
}

export function useAdminOutboxDetail(messageId: string | null) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminOutboxDetailQueryKey(messageId ?? 'none'),
    queryFn: () => getAdminOutboxById(messageId ?? ''),
    enabled: isPlatformAdmin && messageId !== null,
  });
}
